import { MergeDataCommon } from "_fil_local_addon/camc-cms-base/index";

const Fuse = require("./fuse.min.js");
const Paginator = require("_fil_local_addon/camc-cms-base/amc_paginator");
const AUTOSCROLL_SPEED = 1000;
const FUND_URL = "/solutions/mutual-funds/fund/";
const CONTENT_SIZE = 10000;

/**
 * Search Results
 *
 * This class handles the retrieval, filtering, display and pagination of search
 * results from both the Fund Finder API and the CMS ElasticSearch.
 *
 * fundsEnabled argument determines whether to include the fund searching from
 * the Fund Finder service.
 */
class SearchPaginator extends Paginator {
    constructor(rootEl, fundsEnabled) {
        super(rootEl);

        this.allFunds = [];
        this.fundResults = [];
        this.cmsResults = [];

        this.fundsEnabled = fundsEnabled;
        this.filter = "__all__";
        this.lastSearch = undefined;

        this.$resultTemplate = this.$root.find(".search-result.search__template");

        this.hideMenuSearch();
        this.setScrollRestoration();
    }

    hideMenuSearch() {
        $(".menu .search-wrapper").css("display", "none");
        let value = this.getUrlParameter("query_text");

        if (value.length >= 1) {
            $(".resultsPage #camcsearch").addClass("fill").removeAttr("disabled");
        }
    }

    getResults() {
        const fundResults = this.fundResults || [];
        const cmsResults = this.cmsResults || [];
        switch (this.filter) {
            case "__all__":
                return fundResults.concat(cmsResults);
            case "fund":
                return fundResults;
            case "others":
                return cmsResults;
            default:
                return cmsResults.filter((res) => res.type === this.filter);
        }
    }

    /**
     * Retrieve the results for a particular page.
     *
     * @return {array} Array of results in a format understood by buildResult()
     */
    getResultsForPage(page) {
        const results = this.getResults();
        const start = page * this.perPage;
        const end = (page + 1) * this.perPage;
        return results.slice(start, end);
    }

    /**
     * Calculate the maximum number of pages for the current search result
     */
    getMaxPages() {
        const pages = Math.ceil(this.getResults().length / this.perPage);
        return Math.max(0, pages);
    }

    /**
     * Retrieve the total number of results
     *
     * @return {number} Total results
     */
    getTotalResults() {
        return this.getResults().length;
    }

    setPage(page) {
        super.setPage(page);
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            400,
        );
    }

    setPerPage(perPage) {
        super.setPerPage(perPage);
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            400,
        );
    }
    /**
     * Scroll smoothly to the top of the screen
     */
    onPageChange() {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            AUTOSCROLL_SPEED,
        );
    }

    /**
     * Set the filter.
     *
     * If the filter has changed, set the page back to 0 and rebuild the view.
     * @param {string} filter String to filter by
     */
    setFilter(filter) {
        if (this.filter !== filter) {
            this.filter = filter;
            this.page = 0;
            this.rebuild();
        }
    }

    /**
     * Build the DOM for a single result
     * @param {object} result Data for a single result
     * @return {DOM Element}  DOM element representing the result
     */
    buildResult(result) {
        // Clone and append template
        let resultType = result.type;
        let searchType = result.searchType || "article";

        if (resultType == "fund") {
            resultType = "cathaypacificfunds";
        } else if (resultType == "Article") {
            resultType = searchType.toLowerCase();
        }
        const el = this.$resultTemplate
            .clone()
            .removeClass("search__template")
            .addClass(`search-result--${resultType}`);

        if (resultType == "cathaypacificfunds") {
            const title = result.shortNameCN;
            const url = FUND_URL + result.id;
            const fundCode = "代码:" + result.fundCode;
            const fundType = result.fundTypeCN;

            const fundNav = this.checkType(result.nav, result.navDecimalPlace);
            const priceDate = fundNav && fundNav != "=" ? this.checkPriceDate(result.priceDate) : "";

            const dailyPerformance = this.checkTypePerformance(result.changeInPer);
            const accumulatedPrice = this.checkType(result.accumulatedPrice, result.accumulatedPriceDecimalPlace);
            const accumulatedPriceDate =
                accumulatedPrice && accumulatedPrice != "-" ? this.checkPriceDate(result.accumulatedPriceDate) : "";

            el.find(".search-result__fund-code").html(fundCode);
            el.find(".search-result__fund-type").html(fundType);
            el.find(".search-result__fund-nav").html(fundNav + "&nbsp;");
            el.find(".search-result__price-date").html(priceDate);
            el.find(".search-result__daily-performance").html(dailyPerformance);
            el.find(".search-result__accumulated-price").html(accumulatedPrice + "&nbsp;");
            el.find(".search-result__accumulated-price-date").html(accumulatedPriceDate);
            el.find(".search-result__article").css("display", "none");
            el.find(".search-result__link").attr("href", url).html(title);
            el.find(".search-result__code-link").attr("href", url);

            // 互认基金不显示净值变动和累计净值
            if (fundType === "互认基金") {
                el.find(".search-result__detail-performance").remove();
                el.find(".search-result__detail-accumulated").remove();
            }
        } else {
            let content = result.content;
            let target = "_self";
            if (resultType == "pdf") {
                let publishDate = new Date(result.publishDate),
                    month = "" + (publishDate.getMonth() + 1),
                    day = "" + publishDate.getDate(),
                    year = publishDate.getFullYear();

                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;

                publishDate = [year, month, day].join("/");
                content = publishDate;
                target = "_blank";
            }
            el.find(".search-result__content").css("display", "none");
            el.find(".search-result__article-excerpt").html(content);
            el.find(".search-result__article-link").attr("href", result.url).attr("target", target).html(result.title);
        }

        return el;
    }

    checkType(str, fixedNum) {
        if (str === undefined) {
            return "-";
        } else {
            return MergeDataCommon.formatNumber(str, fixedNum ? fixedNum : 4);
        }
    }

    checkPriceDate(str) {
        if (str === undefined) {
            return "";
        } else {
            return "(" + str + ")";
        }
    }

    checkTypePerformance(str) {
        if (str === undefined) {
            return "-";
        } else {
            let dailyPerformance = MergeDataCommon.formatNumber(str, 2);
            if (dailyPerformance == 0) {
                return "<span>" + dailyPerformance + "%<span>";
            } else if (dailyPerformance > 0) {
                return '<span class=" number text-primary-red" >+' + dailyPerformance + "%<span>";
            } else {
                return '<span class=" number text-green" >-' + dailyPerformance + "%<span>";
            }
        }
    }
    /**
     * Displays the loading spinner
     */
    addSpinner() {
        $(".search-results__spinner-container").show();
    }

    /**
     * Removes the loading spinner
     */
    removeSpinner() {
        $(".search-results__spinner-container").hide();
        $(".resultsCount").removeClass("invisible");
    }

    /**
     * Initiate a new search
     */
    search(term) {
        if (this.lastSearch !== term) {
            this.lastSearch = term;
            this.page = 0;
            this.addSpinner();
            $.when(this.searchFunds(term), this.searchArticles(term)).done((fundResults, articleResults) => {
                const fund_array = fundResults || [];
                const fund_codes = $(".fund_codes").text() || "";
                const filter_funds = [];

                for (const fund of fund_array) {
                    if (fund_codes.indexOf(fund.id) > -1) {
                        filter_funds.push(fund);
                    }
                }

                this.fundResults = filter_funds;
                this.cmsResults = articleResults || [];

                let searchTabs = $("#search-result-tabs li a");
                if (searchTabs && searchTabs.length >= 3) {
                    let allResult = this.fundResults.length + this.cmsResults.length;
                    searchTabs[0].innerText = "所有结果 (" + allResult + ")";
                    searchTabs[1].innerText = "产品服务 (" + this.fundResults.length + ")";
                    searchTabs[2].innerText = "其他项目 (" + this.cmsResults.length + ")";
                }
                this.rebuild();
                this.removeSpinner();
            });
        }

        if (term == "") {
            $(".search-result-container").css("display", "none");
        }
    }

    searchFunds(term) {
        const esHostname = $("meta[name=es-api-origin]").attr("content");
        const fundUrl = esHostname + "/es/searchfunds";
        var paramJson = {
            keyword: term,
            size: CONTENT_SIZE,
        };

        const dfd = $.Deferred();
        $.ajax({
            url: fundUrl,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(paramJson),
            success: (response) => {
                dfd.resolve(response?.hits || []);
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error(textStatus, errorThrown);
                dfd.resolve([]);
            },
        });

        return dfd.promise();
    }

    /**
     * Call the DjangoCMS ElasticSearch API to query for CMS content
     * @param  {string} term Term to filter by
     */
    searchArticles(term) {
        const esHostname = $("meta[name=es-api-origin]").attr("content");
        const articleUrl = esHostname + "/es/searcharticles";
        var paramJson = {
            keyword: term,
            size: CONTENT_SIZE,
        };

        const dfd = $.Deferred();
        $.ajax({
            url: articleUrl,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(paramJson),
            success: (response) => {
                dfd.resolve(response?.hits || []);
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error(textStatus, errorThrown);
                dfd.resolve([]);
            },
        });
        return dfd.promise();
    }

    /**
     * Generate the HTML for the paginator navigation. Includes the next and
     * previous page arrow buttons, and digit buttons for navigating to
     * individual pages.
     * overwrite the Paginator method
     */
    buildNavigation() {
        const buttonCount = super.getNavButtonCount();
        const maxPages = this.getMaxPages();
        const total = this.getTotalResults();

        // Hide the entire pagination if there are not multiple pages
        this.$navigation.toggleClass("hide", maxPages < 2);

        // Hide the container of the per page input if there are less than 10 items
        this.$perPageInputContainer.toggleClass("hide", total < 11);

        // Calculate the smallest value to display as a pagination button
        let startAt;
        startAt = this.page - Math.floor(buttonCount / 2);
        startAt = Math.min(startAt, maxPages - buttonCount);
        startAt = Math.max(0, startAt);

        // Determine whether to show the arrows
        $(".paginator__nav-button--prev").toggleClass("invisible", this.page == 0 || maxPages <= buttonCount);

        $(".paginator__nav-button--next").toggleClass(
            "invisible",
            this.page == maxPages - 1 || maxPages <= buttonCount,
        );

        // Remove the existing digit buttons
        this.$navigation.find(".paginator__nav-button--digit").off("click").remove();

        // Generate new digit buttons
        const limit = Math.min(maxPages, buttonCount);
        const nextButton = this.$navigation.find(".paginator__nav-button--next");

        for (let i = 0; i < limit; i++) {
            super.buildNavButton(startAt + i).insertBefore(nextButton);
        }
    }

    /**
     * Search through the funds list. Uses Fuse.js for the client-side search.
     * http://fusejs.io/
     */
    searchDEFunds(term) {
        return [];
    }

    getUrlParameter(name) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
        let results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
}

module.exports = SearchPaginator;
